import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { LoadingController, NavController, AlertController, Platform, ModalController, ToastController } from '@ionic/angular';
import { PassaObjetoService } from '../../services/passa-objeto.service';
import { AuthService } from '../../services/user/auth.service';
import { Router } from '@angular/router';
import { DadosService } from '../../services/dados/dados.service';
import jsPDF from 'jspdf';
@Component({
  selector: 'app-vacina-detalhes',
  templateUrl: './vacina-detalhes.page.html',
  styleUrls: ['./vacina-detalhes.page.scss'],
})
export class VacinaDetalhesPage implements OnInit {
  vacina: any;
  vacinas: any;
  cdmatricula: any;
  vacinaObj: any;
  logado: any;
  usuario: any;
  formDataOut = new FormData();
  fileData = false
  novoArquivo: any
  vacinaSpinner = false;
  public loading: HTMLIonLoadingElement;
  form = {
    "dataDose": "",
    "cdmatricula": "",
    "codvacina": "",
    "extensaoArquivo": ""
  }


  @ViewChild('fileInput', { static: false })
  fileInput: ElementRef;


  constructor(
    public loadingController: LoadingController,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    public navCtrl: NavController,
    public toastCtrl: ToastController,
    public modalController: ModalController,
    public alertController: AlertController,
    private passaObjetoService: PassaObjetoService,
    private authService: AuthService,
    private router: Router,
    private dadosService: DadosService,
  ) {
    this.vacina = this.passaObjetoService.navParams.vacina
    this.cdmatricula = this.passaObjetoService.navParams.codusuario
    this.vacinas = this.passaObjetoService.navParams.vacinas
    this.passaObjetoService.navParams = null


  }

  ngOnInit() {
    this.authService.usuario.subscribe(usr => {
      if (usr.toString() !== "UNAUTHORIZED") {
        this.logado = true
        this.usuario = usr
      } else {
        this.router.navigateByUrl('/home');
      }
    })
    this.montaVacinaObj();
  }

  dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/png' });
    return blob;
  }

  async chamaAlerta(message, buttons) {
    const alert = await this.alertCtrl.create({
      message,
      buttons
    });
    await alert.present();
  }
  async presentToast(message, color, duration) {
    const toast = await this.toastCtrl.create({
      message,
      mode: 'ios',
      position: 'middle',
      color,
      duration,
    });
    toast.present();
  }
  montaVacinaObj() {
    var dateMin = new Date();
    var monthMin = (dateMin.getMonth())
    var dayMin = (dateMin.getDate())
    var yearMin = (dateMin.getFullYear());
    var maxEventDate = new Date(yearMin, monthMin, dayMin).toISOString().substring(0, 10);
    var minEventDate = new Date(2020, 11, 1).toISOString().substring(0, 10);
    this.vacinaObj = {
      maxEventDate: maxEventDate,
      minEventDate: minEventDate,
      vacinaData: this.vacina.datadose,
      vacinaCod: this.vacina.codvacina,
      certificado: this.vacina.certificado,
    }
    this.fileData = this.vacina.certificado;

    function getFirstPart(str) {
      return str.split('/')[0];
    }
    function getSecondPart(str) {
      return str.split('/')[1];
    }

    let fileType = this.vacina.extensaoArquivo;
    // console.log(fileType)
    let fileExtension = getSecondPart(fileType)
    this.vacinaObj.fileType = getFirstPart(fileType)
    this.form.extensaoArquivo = fileType
    const base64 = this.vacina.certificado;
    const fileName = 'name.' + fileExtension;
    const fileBlob = this.dataURItoBlob(base64);
    this.formDataOut.append("file", new File([fileBlob], fileName, { type: fileType }));

    if (getFirstPart(fileType) === 'image') {
      this.vacinaObj.certificado = 'data:image/jpeg;base64,' + this.vacina.certificado
    }
  }


  // Image Preview
  public uploadFile(event: { target: { files: any[]; }; }) {
    this.fileData = false
    this.form.extensaoArquivo = "PDF"
    let file = event.target.files[0]
    function isFileImage(file) {
      return file && file['type'].split('/')[0] === 'image';
    }
    if (file.size > 5000000) {
      this.fileInput.nativeElement.value = "";
      let message = "O arquivo teve ter, no máximo, 6MB de tamanho.  Por favor, reduza o tamanho deste ou selecione outro arquivo"
      let buttons = [{ text: 'Ok', role: 'cancel' }]
      this.chamaAlerta(message, buttons)
      return
    }
    if (isFileImage(file)) {
      let reader = new FileReader();
      if (event.target.files && event.target.files.length > 0) {
        let file = event.target.files[0];
        reader.readAsDataURL(file);
        reader.onload = () => {
          var doc = new jsPDF("p", "pt", "a4");
          var width = doc.internal.pageSize.getWidth() - 100;
          var height = doc.internal.pageSize.getHeight() - 200;
          this.resizeImage(reader.result, width, height).then(compressed => {
            let image = compressed['data']
            let w = compressed['iw']
            let h = compressed['ih']
            const marginX = (doc.internal.pageSize.getWidth() - w) / 2;
            const base64ImgString = image.toString();
            doc.setFontSize(16);
            doc.text('MPRJ - ComVocê', 30, 30 );
            doc.setFontSize(12);
            doc.text("VACINA - "  + this.usuario.Nome+ ' | ' + this.usuario.cdmatricula , 30, 50);
            doc.setFontSize(10);
            doc.text(this.usuario.email.toString(), 30, 70);
            doc.addImage(base64ImgString, 'JPEG', marginX, 100, w, h);
            var blob = new Blob([doc.output("blob")], { type: "application/pdf" });
            this.novoArquivo = blob
            this.formDataOut.delete("file");
            this.formDataOut.append("file", blob, "document.pdf");
          //  doc.save('exame-' + this.usuario.cdmatricula )
          this.fileData = true
          })
        };
      }
    } else {// fim isFileImage
      this.formDataOut.delete("file");
      this.formDataOut.append("file", file);
      this.fileData = true
    }
  }

  resizeImage(src, newX, newY) {
    return new Promise((res, rej) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        var iw = img.width;
        var ih = img.height;
        if (iw > ih) {
          if (iw > newX) {
            ih *= newX / iw;
            iw = newX;
          }
        } else {
          if (ih > newY) {
            iw *= newY / ih;
            ih = newY;
          }
        }
        const elem = document.createElement('canvas');
        elem.width = iw;
        elem.height = ih;
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, iw, ih);
        const data = ctx.canvas.toDataURL()
        res({ data, iw, ih });
      }
      img.onerror = error => rej(error);
    })
  }

  abrePDF(arquivo) {
    var byteCharacters = atob(arquivo);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    var file = new Blob([byteArray], { type: 'application/pdf;base64' });
    var fileURL = URL.createObjectURL(file);
    window.open(fileURL);
  }
  async updateVacina(vacinaObj) {
    this.loading = await this.loadingCtrl.create();
    await this.loading.present();
    this.form = {
      codvacina: vacinaObj.vacinaCod,
      cdmatricula: this.usuario.cdmatricula,
      dataDose: vacinaObj.vacinaData,
      extensaoArquivo: this.form.extensaoArquivo,
    }
    let id = this.vacina.id
    this.formDataOut.append("form", JSON.stringify(this.form));
    this.formDataOut.append("id", id);
  //  this.formDataOut.append("file", this.fileData);
    this.dadosService.updateVacinaUser(this.formDataOut)
      .subscribe(data => {
        console.log(data)
        this.formDataOut.delete("file");
        this.formDataOut.delete("form");
        this.formDataOut.delete("id");
        this.fileData = null
        if (data['cod'] == 200) {
          this.loading.dismiss().then(() => {
            let message = "Imunização alterada com sucesso!"
            this.presentToast(message, 'success', 2000)
            this.router.navigate(['/novo-vacina'], { queryParams: { action: 'update' } });
          });
        }
        if (data['cod'] == 400) {
          this.loading.dismiss().then(() => {
            let message = "Falha na execução. Confira os dados e tente novamente em alguns minutos."
            let buttons = [{ text: 'Ok', role: 'cancel' }]
            this.chamaAlerta(message, buttons)
          });
        }
      },
        err => {
          this.loading.dismiss()
          console.log(err)
          if (err.status == 400) {
            let message = "Falha na execução. Confira os dados e tente novamente em alguns minutos."
            let buttons = [{ text: 'Ok', role: 'cancel' }]
          this.chamaAlerta(message, buttons)
          }

        },
        () => console.log('ok')
      );

  }

  excluirVacina(vacina) {

    // console.log(vacina)
    let message = "Deseja realmente excluir esta vacinação?  Esta ação não poderá ser desfeita."
    let buttons = [{ text: 'Não', role: 'cancel' }, {
      text: 'sim, excluir',
      handler: () => {
        this.deleteVacina(vacina)
      }
    }]
    this.chamaAlerta(message, buttons)
  }

  async deleteVacina(vacina) {
    this.loading = await this.loadingCtrl.create();
    await this.loading.present();
    this.dadosService.deleteVacinaUsuario(vacina.id)
      .subscribe((event) => {
        if (event['cod'] == 200) {
          this.loading.dismiss().then(() => {
            let message = "Imunização excluída com sucesso!"
            let buttons = [{ text: 'Ok', role: 'cancel' }]
            this.chamaAlerta(message, buttons)
            this.router.navigate(['/novo-vacina'], { queryParams: { action: 'update' } });
          });
        }
        if (event['cod'] == 400) {
          this.loading.dismiss().then(() => {
            let message = "Falha na execução. Confira os dados e tente novamente em alguns minutos."
            let buttons = [{ text: 'Ok', role: 'cancel' }]
            this.chamaAlerta(message, buttons)
          });
        }
      }
        ,
        err => {
          this.loading.dismiss()
          console.log(err)
          if (err.statusText == 400) {
            let message = "Falha na execução. Confira os dados e tente novamente em alguns minutos."
            let buttons = [{ text: 'Ok', role: 'cancel' }]
            this.chamaAlerta(message, buttons)
          }

        },
        () => console.log('ok')
      );
  }

}
